import { ContainerDivider, DividerLine } from './styles';

const DividerWrapper = () => {
    return (
        <ContainerDivider>
            <DividerLine/>
        </ContainerDivider>
    )

}
export default DividerWrapper;
